import React from "react";
import {
  Box,
  Button,
  CircularProgress,
  MenuItem,
  FormControl,
  Select,
  styled,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";

import { Typography } from "components/Typography";
import { useGetRoles, useUpdateRoleMutation } from "api/roles";

const Title = styled("h2")(() => ({
  fontSize: "20px",
  fontFamily: "BR Firma",
  fontWeight: 600,
  textAlign: "center",
}));

const TextWrapper = styled(Box)(() => ({
  padding: "10px 0px",
}));

export const ChangeRole = ({ data: tableData, onRoleUpdate, onClose }) => {
  const { data: roles } = useGetRoles();

  const { mutate: updateRole, isPending } = useUpdateRoleMutation({
    roleId: tableData.accountId,
  });

  const formik = useFormik({
    initialValues: {
      selectedRole: tableData?.roles || "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      selectedRole: Yup.string().required("Please select a role"),
    }),
    onSubmit: (values) => {
      const selectedRoleData = roles?.find(
        (role) => role.roleId === values.selectedRole
      );

      if (!selectedRoleData) return;

      const data = {
        name: selectedRoleData.name,
        description: selectedRoleData.description || "",
        permissionId: [values.selectedRole],
      };

      updateRole(
        { data },
        {
          onSuccess: () => {
            onRoleUpdate(tableData.id, selectedRoleData.name);
            onClose(); // ✅ Closes modal after success
          },
          onError: () => {
            // Optional: handle error
          },
        }
      );
    },
  });

  return (
    <div>
      <FormControl sx={{ width: "100%", paddingBottom: "10px" }}>
        <Title>Change Role</Title>
      </FormControl>

      <div>
        <FormControl sx={{ width: "100%", py: "10px" }}>
          <TextWrapper>
            <Typography variant="loginLabel">Role</Typography>
          </TextWrapper>
          <Select
            name="selectedRole"
            value={formik.values.selectedRole}
            onChange={formik.handleChange}
            displayEmpty
            error={
              formik.touched.selectedRole && Boolean(formik.errors.selectedRole)
            }
          >
            <MenuItem value="">
              <em>Select Role</em>
            </MenuItem>
            {roles?.map((role) => (
              <MenuItem key={role.roleId} value={role.roleId}>
                {role.name}
              </MenuItem>
            ))}
          </Select>
          {formik.touched.selectedRole && formik.errors.selectedRole && (
            <div style={{ color: "red", fontSize: "12px" }}>
              {formik.errors.selectedRole}
            </div>
          )}
        </FormControl>

        <Button
          disableRipple
          type="submit"
          variant="contained"
          sx={{
            width: "100%",
            margin: "30px 0px",
            textTransform: "capitalize",
          }}
          size="large"
          disabled={isPending}
          onClick={formik.handleSubmit}
        >
          Change Role
          {isPending && (
            <CircularProgress size={18} sx={{ ml: 0.5, color: "#fff" }} />
          )}
        </Button>
      </div>
    </div>
  );
};
